/**
 * O itinerário como lista de vias — porta `cteatf_itinerario.dart`.
 *
 * A regra que atravessa o arquivo: o texto dele é dele. Estas funções
 * acrescentam e removem uma via; não normalizam, não reordenam e não
 * reescrevem o que já estava no campo.
 */

/** Uma via, como aparece escrita: letras seguidas de números, com ou sem separador. */
const VIA = /(?<![A-Za-z0-9])([A-Za-z]{1,4})[\s.-]?([0-9]{1,5})(?![A-Za-z0-9])/g;

/** Vírgula — separador do próprio hint do campo, ASCII (vai para o portal do DER). */
export const SEPARADOR_ITINERARIO = ', ';

function normalizar(s: string): string {
  return s.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

/** As vias já citadas, normalizadas para comparação. */
export function rodoviasNoItinerario(itinerario: string): Set<string> {
  const resultado = new Set<string>();
  for (const m of itinerario.matchAll(VIA)) {
    resultado.add(normalizar(`${m[1]}${m[2]}`));
  }
  return resultado;
}

function removerVia(itinerario: string, sigla: string): string {
  const letras = (sigla.trim().match(/^[A-Za-z]+/) ?? [''])[0];
  const digitos = (sigla.trim().match(/[0-9]+$/) ?? [''])[0];
  if (!letras || !digitos) return itinerario;

  const re = new RegExp(`(?<![A-Za-z0-9])${letras}[\\s-]?${digitos}(?![A-Za-z0-9])`, 'gi');
  let r = itinerario.replace(re, '');
  r = r.replace(/\s*([,;/>→])\s*(?=[,;/>→])/g, '');
  r = r.replace(/\s{2,}/g, ' ');
  return r.replace(/^[\s,;/>→-]+|[\s,;/>→-]+$/g, '');
}

/**
 * Acrescenta a via se não estiver lá; remove se estiver.
 * `null` quando acrescentar estouraria `max` — a tela avisa em vez de
 * truncar (truncar inventaria uma via que não existe, e ela vai ao documento).
 */
export function alternarRodovia(itinerario: string, sigla: string, max: number): string | null {
  const alvo = normalizar(sigla);
  if (!alvo) return itinerario;

  if (rodoviasNoItinerario(itinerario).has(alvo)) {
    return removerVia(itinerario, sigla);
  }

  const base = itinerario.trimEnd();
  const nova = base === '' ? sigla : `${base}${SEPARADOR_ITINERARIO}${sigla}`;
  return nova.length > max ? null : nova;
}
